"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiDisplaySplashScreenCheckBox = void 0;
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
var _pixi = require("pixi.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiDisplaySplashScreenCheckBox = exports.PixiDisplaySplashScreenCheckBox = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiDisplaySplashScreenCheckBox(name, breadTextFont) {
    var _this;
    _classCallCheck(this, PixiDisplaySplashScreenCheckBox);
    _this = _callSuper(this, PixiDisplaySplashScreenCheckBox, [name]);
    _defineProperty(_this, "unsub", void 0);
    _defineProperty(_this, "text", void 0);
    var boxSprite = new _pixi.Sprite();
    _this.unsub = _core.CORE.subscribe('config.splashScreenHide', function (e) {
      if (e) boxSprite.texture = _pixi.Texture.from("spl_box_checked.png");else boxSprite.texture = _pixi.Texture.from("spl_box.png");
    });
    _this.text = new _pixi.Text(_core.CORE.translate('splashDesktopDontShowAgain'),
    //"Don't show again",
    {
      fill: 0xFFFFFF,
      fontFamily: breadTextFont,
      fontSize: 18
    });
    _this.text.resolution = 2;
    _this.text.anchor.set(0, 0.5);
    _this.interactive = true;
    _this.buttonMode = true;
    _this.text.position.set(boxSprite.width + 10, boxSprite.height / 2);
    _this.on('mousedown', function (e) {
      e.stopPropagation();
      _core.CORE.dispatch({
        type: _core.SPLASH_SCREEN_HIDE_TOGGLE
      });
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, 'uitoggle'));
    });
    _this.on('touchstart', function (e) {
      e.stopPropagation();
      _core.CORE.dispatch({
        type: _core.SPLASH_SCREEN_HIDE_TOGGLE
      });
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, 'uitoggle'));
    });
    _this.addChild(boxSprite, _this.text);
    _this.setAnchor(0.5);
    _this.y = 473;
    _this.x = 391;
    return _this;
  }
  _inherits(PixiDisplaySplashScreenCheckBox, _PixiGameComponent);
  return _createClass(PixiDisplaySplashScreenCheckBox, [{
    key: "destroy",
    value: function destroy(options) {
      if (this.unsub) this.unsub();
      _superPropGet(PixiDisplaySplashScreenCheckBox, "destroy", this, 3)([options]);
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiDisplaySplashScreenCheckBox.js.map